import { Directive, ElementRef,Renderer, HostListener, Input, AfterViewInit, Output, EventEmitter } from '@angular/core';
import * as $ from 'jquery';


@Directive({
    selector: '[ngModel][HijriPicker]',
    host: {
      "(input)": 'onInputChange($event)'
          }
})
export class HijriPicker implements AfterViewInit{

  @Output() ngModelChange:EventEmitter<any> = new EventEmitter()
  value: any
    constructor(private renderer: Renderer,private el: ElementRef)
    {
                 
    }
    onInputChange($event){
     /* this.value = $event.target.value;
        alert(this.value);
      this.ngModelChange.emit(this.value)*/
      }
    ngAfterViewInit() {     
      var j = jQuery.noConflict();
     var res=this.el.nativeElement;
    

      j(this.el.nativeElement).calendarsPicker({calendar: j.calendars.instance('islamic'),dateFormat: 'dd-mm-yyyy',onClose:  ()=>{
       this.ngModelChange.emit(j(res).val())
        
      }});     
      
    }
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Directives/HijriPicker.ts